// https://nuxt.com/docs/guide/directory-structure/app-config#app-config-file
export default defineAppConfig({
    ui: {
        colors: {
            // flame = laranja da marca Leadins (escala em assets/css/main.css)
            primary: "flame",
            secondary: "blue",
            info: "cyan",
            neutral: "stone",
            // cores de contexto de serviço do Design System Leadins
            hunting: "loblolly",
            consulting: "mahogany",
        },
        badge: {
            slots: {
                // pills do Design System (Claude Design "Detalhe Empresa"): raio 999px
                base: "rounded-full",
            },
        },
        switch: {
            slots: {
                // trilha desligada em bg-accented some sobre cartões no modo claro
                base: "data-[state=unchecked]:bg-neutral-300 dark:data-[state=unchecked]:bg-accented",
                thumb: "bg-white dark:bg-default",
            },
        },
    },
})
